import React from "react";
import Message from "../../../i18n/Message";

const ToggleSwitch = ({
  onChange,
  value,
  optionLeft,
  optionRight,
  inline = true,
}) => {
  return (
    <div
      className={
        inline ? "toggle_switch_container_inline" : "toggle_switch_container"
      }
    >
      {optionLeft.label && (
        <div
          className={
            value === optionLeft.value ? "switch_label_active" : "switch_label"
          }
          onClick={() => onChange(optionLeft.value)}
        >
          <Message id={optionLeft.label} />
        </div>
      )}
      <div className="toggle-content">
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={value === optionRight.value}
            onChange={() =>
              onChange(
                value === optionRight.value
                  ? optionLeft.value
                  : optionRight.value
              )
            }
          />
          <span className="toggle-slider toggle-round"></span>
        </label>
      </div>
      {optionRight.label && (
        <div
          className={
            value === optionRight.value ? "switch_label_active" : "switch_label"
          }
          onClick={() => onChange(optionRight.value)}
        >
          <Message id={optionRight.label} />
        </div>
      )}
    </div>
  );
};

export default ToggleSwitch;
